<div class="setting-page">
  <legend>Configurator Credentials</legend>

  <div class="action-buttons">
    <arm-action-bar (addClick)="addItem()" [disableAdd]="isUnauthorized"
                    (deleteClick)="removeItem()" [disableDelete]="!selection || isUnauthorized"
                    (refreshClick)="refresh()"
                    (editClick)="editItem()" [disableEdit]="!selection || isUnauthorized"></arm-action-bar>
  </div>

  <div class="credentials-table">
    <arm-table [displayedColumns]="displayedColumns"
               (onSelection)="onSelection($event)" [data]="items"
               [isMultipleSelection]="false"
               [isClientSide]="true"></arm-table>
  </div>
</div>
